(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDeleteController',RealtyTypeDeleteController);

    RealtyTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RealtyType'];

    function RealtyTypeDeleteController($uibModalInstance, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RealtyType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
